// src/components/ScrollToTop.jsx (for React Router v5.1+ with hooks)
import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";

function ScrollToTop() {
  const location = useLocation(); // Get the location object

  useEffect(() => {
    window.scrollTo(0, 0); // Scroll to the top when location changes
  }, [location.pathname]); // Dependency array: re-run effect when pathname changes

  return null;
}

export default ScrollToTop;
